const DEFAULT_THUMBNAIL_SIZE = [64, 64];

export default DEFAULT_THUMBNAIL_SIZE;
